import React from "react";
import { motion } from "framer-motion";
import { Building2, Plus, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut",
    },
  },
};

const EmptyWorkspaceState = ({ onCreateWorkspace }) => {
  const { t } = useTranslation();
  return (
    <motion.div
      className="flex min-h-[calc(100vh-72px)] items-center justify-center bg-[#F8F9FA] px-6"
      variants={pageVariants}
      initial="initial"
      animate="animate"
    >
      <div className="max-w-md text-center">
        {/* Illustration */}
        <div className="relative mb-8 inline-flex items-center justify-center">
          {/* Background glow */}
          <div
            className="absolute h-32 w-32 rounded-full"
            style={{
              background:
                "radial-gradient(circle, rgba(232, 133, 74, 0.15) 0%, rgba(232, 133, 74, 0) 70%)",
            }}
          />

          {/* Main icon container */}
          <div
            className="relative flex h-20 w-20 items-center justify-center rounded-2xl"
            style={{
              background: "linear-gradient(135deg, #E8854A 0%, #D66B2E 100%)",
              boxShadow: "0 8px 24px rgba(224, 122, 58, 0.25)",
            }}
          >
            <Building2 size={36} className="text-white" />
          </div>

          {/* Sparkle decoration */}
          <div className="absolute -right-1 -top-1">
            <Sparkles size={20} className="text-[#E07A3A]" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="mb-3 text-2xl font-bold text-[#111827]">
          {t("navigation.emptyWorkspace.title")}
        </h1>

        {/* Description */}
        <p className="mb-8 text-[15px] leading-relaxed text-[#6B7280]">
          {t("navigation.emptyWorkspace.description")}
        </p>

        {/* CTA Button */}
        <button
          onClick={onCreateWorkspace}
          className="inline-flex items-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold text-white transition-all duration-150 hover:scale-[1.02] active:scale-[0.98]"
          style={{
            background: "linear-gradient(135deg, #E8854A 0%, #D66B2E 100%)",
            boxShadow: "0 4px 14px rgba(224, 122, 58, 0.35)",
          }}
        >
          <Plus size={18} strokeWidth={2.5} />
          {t("navigation.emptyWorkspace.createFirst")}
        </button>

        {/* Helper text */}
        <p className="mt-6 text-xs text-[#9CA3AF]">
          {t("navigation.emptyWorkspace.helper")}
        </p>
      </div>
    </motion.div>
  );
};

export default EmptyWorkspaceState;
